import { useField } from "formik"

//Referal modules
import RefGoogleAutoComplete, {
  RefGetAddressFromPlace,
} from "../Input/RefTextInputGooglePlaces"

//JSON Resources
import us_states from "../../../../resources/us_states.json"
import { useRef } from "react"

/* export interface Props {
    label: string;
    defaultValue?: string;
    
} */

export default function ReferralEntityFormPlacesInput({
  label,
  defaultValue,
  isInitialLoad,
  isLoading,
  locationIndex,
  helpText,
}) {
  const [, , addressHelper] = useField(
    `referralLocations[${locationIndex}].location.address`
  )
  const [, , cityHelper] = useField(
    `referralLocations[${locationIndex}].location.city`
  )
  const [, , stateHelper] = useField(
    `referralLocations[${locationIndex}].location.state`
  )
  const [, , zipHelper] = useField(
    `referralLocations[${locationIndex}].location.zipcode`
  )
  const [, , countryHelper] = useField(
    `referralLocations[${locationIndex}].location.country`
  )
  const [, , longHelper] = useField(
    `referralLocations[${locationIndex}].location.longitude`
  )
  const [, , latHelper] = useField(
    `referralLocations[${locationIndex}].location.latitude`
  )

  const addressRef = useRef(addressHelper)
  const cityRef = useRef(cityHelper)
  const stateRef = useRef(stateHelper)
  const zipRef = useRef(zipHelper)
  const countryRef = useRef(countryHelper)
  const longRef = useRef(longHelper)
  const latRef = useRef(latHelper)

  addressRef.current = addressHelper
  cityRef.current = cityHelper
  stateRef.current = stateHelper
  zipRef.current = zipHelper
  countryRef.current = countryHelper
  longRef.current = longHelper
  latRef.current = latHelper

  function onPlaceChanged(place) {
    const placeDetail = RefGetAddressFromPlace(place)

    if (placeDetail.hadSelection) {
      const state = us_states.filter((x) => x.label === placeDetail.state)
      addressRef.current.setValue(placeDetail.address)
      cityRef.current.setValue(placeDetail.city)
      stateRef.current.setValue(state.length > 0 ? state[0].value : undefined)
      countryRef.current.setValue(placeDetail.country)
      zipRef.current.setValue(placeDetail.zipCode)
      longRef.current.setValue(placeDetail.longitude)
      latRef.current.setValue(placeDetail.latitude)
    }

    return ""
  }

  return (
    <>
      <RefGoogleAutoComplete
        label={label}
        defaultValue={defaultValue}
        onPlaceSelect={onPlaceChanged}
        isInitialLoad={isInitialLoad}
        disabled={isLoading}
      />
      {helpText ? <small style={{ color: "gray" }}>{helpText}</small> : null}
    </>
  )
}
